"use client";

import { useEffect, useState } from "react";
import Office from "./office";
import Googlemap from "./map";
import BottomCurves from "../curves/bottomCurves";
import OfficeMobile from "./officeMobile";

export default function Location({ data }: { data: any }) {
    const [locationAddress, setLocationAddress] = useState(
        data.locations[0].locationDetails.googleMapAddress
    );
    const [selectedOffice, setSelectedOffice] = useState(
        data.locations[0].country
    );

    const handleLocationChange = (newAddress: string, office: string) => {
        setLocationAddress(newAddress);
        setSelectedOffice(office);
    };

    return (
        <section className="py-8 pb-12 md:px-16 md:py-12 md:pb-44 bg-lightGrey">
            <div className="max-md:hidden md:grid lg:grid-cols-12 lg:grid-rows-2 rounded-3xl overflow-hidden shadow-lg">
                {/* Desktop Office location view */}
                <div className="hidden md:block col-span-4 row-span-2">
                    {/* <div className="hidden md:block col-span-4 row-span-2 bg-purple-radial-gradient"> */}
                    {data.locations.map((location: any, index: number) => (
                        <div key={index} className="bg-purple-radial-gradient">
                            <Office
                                location={location}
                                setOfficeAddress={handleLocationChange}
                                isSelected={location.country === selectedOffice}
                            />
                        </div>
                    ))}
                </div>

                <div className="block max-md:hidden col-span-8 row-span-2">
                    <Googlemap address={locationAddress} />
                </div>
            </div>

            {data.locations.map((location: any, index: number) => (
                <div
                    key={index}
                    className="lg:hidden md:grid lg:grid-cols-12 lg:grid-rows-2 rounded-3xl overflow-hidden shadow-lg mb-3"
                >
                    {/* Mobile Office location view new design */}
                    <div className="block md:hidden col-span-4 row-span-1 bg-purple-radial-gradient">
                        <div className="flex flex-wrap justify-center items-center pt-5 md:pt-2 gap-x-2">
                            <>
                                <span
                                    key={`contact` + index}
                                    className="bg-white text-purple border-white flex justify-center body-small-fontsize leading-[1] font-medium px-5 py-3 mt-2 duration-200 border-[1px] rounded-full whitespace-nowrap text-center"
                                >
                                    {location.country}
                                </span>

                                <OfficeMobile
                                    locations={data.locations}
                                    selectedOffice={location.country}
                                />
                            </>
                        </div>
                        <div className="col-span-8 row-span-2">
                            <Googlemap address={locationAddress} />
                        </div>
                    </div>
                </div>
            ))}

            <BottomCurves color="dark purple" direction="right" />
        </section>
    );
}
